module.exports = __webpack_public_path__ + "static/Reto-fd24b2549b169281e519720b6ff7f212.jpg";